export default __webpack_public_path__ + "static/media/bela.Glitch.48bfacf7.png";